module.exports = __webpack_public_path__ + "static/img/avator.0f3ebd5b.jpg";